export var interactions = new Map();